import "./Cooperation.module.css";
import Header from "@/reusable_sections/Header";
import ProjectHero from "./sections/ProjectHero";
import IndustriesBrands from "./sections/IndustriesBrands";
import KeyServices from "./sections/KeyServices";
import DiscussYourCase from "./sections/DiscussYourCase";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function CooperationPage() {
  return <div>
      <Header />
      <ProjectHero />
      <IndustriesBrands />
      <KeyServices />
      <DiscussYourCase />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}